import { ApiPagingConfig } from 'src/app/shared/models/paging/ApiPagingConfig';

export const DEFAULT_CHUNK_SIZE: number = 15;
export const DEFAULT_INTERACTION_CHUNK_SIZE: number = 7;

export const DEFAULT_PAGING_CONFIG: ApiPagingConfig = {
  dir: 'DESC',
  limit: DEFAULT_CHUNK_SIZE,
  start: 0,
  sort: 'last_modified_time'
};

export const TICKET_FILTERS__CHUNK_SIZE = 5;

export const GLOBAL_SEARCH_CHUNK_SIZE = 30;
export const GLOBAL_SEARCH__TRUNCATE_RESULTS_LIMIT = 2;
